module.exports = __webpack_public_path__ + "img/file-earmark-person.7fb263f7.svg";